export const navigationKeys = {
  "Applications & Services": "group0",
  "Account & Security": "group1",
  "Jobs & Automation": "group2",
  "Support & Collaboration": "group3",
  "Digest & Noise Controls": "group4",
  "Fleet Visibility": "group5",
  "General": "group6",
  "Applications": "group7",

  "Dashboard": "Dashboard",
  "Profile": "Profile",
  "Settings": "Settings",
  "System": "System",
  "Software": "Software",
  "Support": "Support",
  "Notifications": "Notifications",
  "Notification Center": "NotificationCenter",
  "General Settings": "GeneralSettings",
  "Email Settings": "EmailSettings",
  "Notification Settings": "NotificationSettings",
  "Session Settings": "SessionSettings",
  "Security Settings": "SecuritySettings",
  "Registration Settings": "RegistrationSettings",
  "System Dashboard": "SystemDashboard",
  "Streaming Dashboard": "StreamingDashboard",
  "App Dashboard": "AppDashboard",
  "App Templates": "AppTemplates",
  "User Admin": "UserAdmin",
  "User Groups": "UserGroups",
  "User Roles": "UserRoles",
  "User Management": "UserManagement",
  "User Registration": "UserRegistration",
  "Web Console": "WebConsole",
  "API Control": "APIControl",
  "API Playground": "APIPlayground",
  "SSL Control": "SSLControl",
  "VPN Control": "VPNControl",
  "Changelog": "Changelog",
  "News": "News",
  "System Logs": "SystemLogs",
  "Audit Log": "AuditLog",
  "Asset Management Center": "AssetManagementCenter",
  "Account": "Account",
  "Activation": "Activation",
  "Activity Logs": "ActivityLogs",
  "Additional dashboard settings": "AdditionalDashboardSettings",
  "Advanced": "Advanced",
  "All notifications": "AllNotifications",
  "Application Backups": "ApplicationBackups",
  "Application Logos": "ApplicationLogos",
  "Auth pages": "AuthPages",
  "Automation & Tools": "AutomationTools",
  "Avatars": "Avatars",
  "Brand Assets": "BrandAssets",
  "Branding": "Branding",
  "CPU & Memory": "CPUMemory",
  "Channel setup": "ChannelSetup",
  "Channels": "Channels",
  "Command Channel": "CommandChannel",
  "Command aliases": "CommandAliases",
  "Communication": "Communication",
  "Compose": "Compose",
  "Concurrency": "Concurrency",
  "Content": "Content",
  "Control Center": "ControlCenter",
  "DB Management": "DBManagement",
  "Default Group": "DefaultGroup",
  "Delete Protection": "DeleteProtection",
  "Devices": "Devices",
  "Diagnostics": "Diagnostics",
  "Disk usage alerts": "DiskUsageAlerts",
  "Display preferences": "DisplayPreferences",
  "Documentation": "Documentation",
  "Download Clients": "DownloadClients",
  "E-Books & Comics": "EBooksComics",
  "Enable & consent": "EnableConsent",
  "Enable support access": "EnableSupportAccess",
  "Fail2Ban Protection": "Fail2BanProtection",
  "Feature flags": "FeatureFlags",
  "File Management": "FileManagement",
  "Firewall Rules": "FirewallRules",
  "Geo-Block": "GeoBlock",
  "Geo-Lock": "GeoLock",
  "Hardware Health": "HardwareHealth",
  "History": "History",
  "History & Analytics": "HistoryAnalytics",
  "Indexers & Trackers": "IndexersTrackers",
  "Instance settings": "InstanceSettings",
  "Inter-Instance Transfer": "InterInstanceTransfer",
  "Inter-Instance Transfers": "InterInstanceTransfers",
  "Linked channels": "LinkedChannels",
  "Local Assets": "LocalAssets",
  "Log": "Log",
  "Media Management": "MediaManagement",
  "Media Portal": "MediaPortal",
  "Media Requests": "MediaRequests",
  "TV Guide": "TvGuide",
  "Media Servers": "MediaServers",
  "Network": "Network",
  "Notification events": "NotificationEvents",
  "Overview": "Overview",
  "Passkeys": "Passkeys",
  "Password Policy": "PasswordPolicy",
  "Persistence & Cookies": "PersistenceCookies",
  "Profile picture": "ProfilePicture",
  "Provider": "Provider",
  "Quick links": "QuickLinks",
  "Quotas": "Quotas",
  "Remote Access": "RemoteAccess",
  "Restricted Shell": "RestrictedShell",
  "Security": "Security",
  "Server Users": "ServerUsers",
  "Service Health": "ServiceHealth",
  "Session Operations": "SessionOperations",
  "Sessions": "Sessions",
  "Sessions & security": "SessionsSecurity",
  "Software RAID": "SoftwareRAID",
  "Streaming Maintenance": "StreamingMaintenance",
  "System Inventory": "SystemInventory",
  "System metrics": "SystemMetrics",
  "Telemetry History": "TelemetryHistory",
  "Templates": "Templates",
  "Timeouts": "Timeouts",
  "Timezone & locale": "TimezoneLocale",
  "Transfer": "Transfer",
  "Two-factor auth": "TwoFactorAuth",
  "Updates Available": "UpdatesAvailable",
  "Updates digest": "UpdatesDigest",
  "Uploads": "Uploads",
  "Username Policy": "UsernamePolicy",
  "Users": "Users",
  "Utilities & System": "UtilitiesSystem",
  "Watch Analytics": "WatchAnalytics",
  "Welcome Email": "WelcomeEmail"
} as const;
